<template>
<inertia-head title="Quick Start Gold" />
<div class="bg-trc-main">
	<div class="bg-black-25">
		<div class="content text-center">
			<div class="py-0">
				<h1 class="fw-bold text-white mb-2">Quick Start - Gold Member</h1>
				<h2 class="h4 fw-normal text-white-75 fs-sm">
				Here are the first steps you need to do to start your investment
				journey.
				</h2>
			</div>
		</div>
	</div>
</div>
<div class="content">
	<div class="row">
		<div class="col-md-5 bg-primary-op shadow mb-3">
			<div class="row align-items-center h-100">
				<div class="col-12 justify-content-center">
					<img
					src="/media/banners/quick-start-gold.jpeg"
					class="img-fluid img-thumbnail"
					alt=""
					/>
				</div>
			</div>
		</div>
		<div class="col-md-7">
			<div class="block block-rounded shadow">
				<div class="block-content block-content-full">
					<h3 class="content-heading fw-semibold">
					Step 1: Open and Fund your COL account
					</h3>
					<ol>
						<li>
							Prepare the following
							<ul>
								<li>
									3 signature samples with your valid government-issued ID on a blank sheet of paper.
								</li>
								<li>Selfie with your valid government-issued ID</li>
							</ul>
						</li>
						<li>
							Go to
							<a
								href="https://signup.colfinancial.com/partnership?code=TRC"
								target="_blank"
								>
								this link
							</a>
						</li>
						<li>Sign-up and follow the steps outlined on that site</li>
					</ol>
					<h3 class="content-heading fw-semibold">
					Step 2: Update contact details
					</h3>
					<ol>
						<li>
							We regularly send email and text messages to our members TRC
							members. Please make sure your mobile phone number is updated
							and correct to get our latest updates quickly.
						</li>
					</ol>
					<h3 class="content-heading fw-semibold">
					Step 3: Attend one of our LIVE TRC quickstart sessions
					</h3>
					<p>
					Come join us for one of our TRC Quickstart sessions! We'll walk you through everything you need to know about our TRC Dashboard. Plus, our friendly COL partners will be there to help you with setting up your COL account and making your first stock purchase. Stick around for a live Q&A session where we can chat and answer any questions you have!</p>
					
					
					<h3 class="content-heading fw-semibold">Step 4: Start learning</h3>
					<p>We strongly encourage you to watch the Silver Class and Gold Class videos as they will be invaluable resources for your investment journey. They're packed with valuable insights to help you along the way.
					</p>
				</div>
			</div>
		</div>
	</div>
</div>
</template>
<script>
window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date());
gtag('config', window.gtag_id);
import { onMounted } from 'vue'
import AuthLayout from '../../Layouts/AuthLayout'
export default {
	layout: AuthLayout,
	setup() {
		onMounted(() => {
			const pageContainer = document.getElementById('page-container')
			if (pageContainer.classList.contains('sidebar-o-xs'))
				pageContainer.classList.remove('sidebar-o-xs')
		})
	},
}
</script>